import { ChangeEvent, useContext } from 'react'
import TextInputField from '../../fields/text-input-field/text-input-field.component'
import { FormProvider } from 'react-hook-form'
import { useMyCompanyForm } from './my-company-form.hooks'
import {
  SettingsContext,
  SettingsProviderValue,
} from 'pages/settings/settings.provider'

const MyCompanyForm = () => {
  const formMethods = useMyCompanyForm()
  const { user, setUser } = useContext(
    SettingsContext
  ) as unknown as SettingsProviderValue

  const handleCompanyNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newCompanyName = e.target.value
    setUser({ ...user, companyName: newCompanyName })
  }

  return (
    <FormProvider {...formMethods}>
      <TextInputField
        placeholder="ABC Logistics"
        name="companyName"
        label="My Company Name"
        value={user?.companyName || ''}
        onChange={handleCompanyNameChange}
        bold
      />
    </FormProvider>
  )
}

export default MyCompanyForm
